import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { DetailPageHeader } from "../../../ui-components/pageLayout/DetailPageHeader";
import { store } from "../../../store";
import {
  ClearChannelAction,
  ClearEPGAction,
  DeleteChannelAction,
  GetChannelAction,
  getLiveChannelSelector,
  getLiveChannelsSelector,
  GetTagsAction,
  getTagsSelector,
  SetChannelAction,
  UpdateChannelAction,
  UpdateAssetEntitlementsAction,
} from "../../../store/reducers/cmsReducer";
import LocalizedImagesAccordion from "../SharedAccordions/LocalizedImagesAccordion";
import EPGAccordion from "./accordions/EPGAccordion";
import ChannelBasicInformationAccordion from "./accordions/ChannelBasicInformationAccordion";
import { CMSAsset } from "@client/models/CMS/cmsAsset";
import LocalizedTextsAccordion from "../SharedAccordions/LocalizedTexts";
import TagsAccordion from "../SharedAccordions/TagsAccordion";
import GenresAccordion from "../SharedAccordions/GenresAccordion";
import MediasAccordion from "../VOD/accordions/MediasAccordion";
import { CMSTag } from "@client/models/CMS/cmsTag";
import MediaAccordion from "../SharedAccordions/MediaAccordion";
import EntitlementsAccordion from "../SharedAccordions/EntitlementsAccordion";

const UpdateChannelSchema = Yup.object().shape({
  originalTitle: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required*"),
});

export const LiveChannel: React.FC = () => {
  const channels = useSelector(getLiveChannelsSelector);
  const channel = useSelector(getLiveChannelSelector);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const history = useNavigate();
  const params = useParams();
  const tags = useSelector(getTagsSelector);
  const [providers, setProviders] = useState<CMSTag[]>([]);

  useEffect(() => {
    store.dispatch(GetTagsAction());
  }, []);

  useEffect(() => {
    // Filter tags to get only providers
    // Potentially use Provider instead of Tag in the future
    const providerTags = tags.filter((tag) => tag.getType() === "provider");
    setProviders(providerTags);
  }, [tags]);

  useEffect(() => {
    if (!channel && !isDeleting && params.id) {
      const foundChannel = channels?.find(
        (channel) => channel.assetId == params.id
      );
      foundChannel
        ? store.dispatch(SetChannelAction(foundChannel.serialize()))
        : store.dispatch(GetChannelAction(params.id));
    } else if (!channel && isDeleting) {
      redirect();
    }
  }, [channels, channel]);

  useEffect(() => {
    return () => {
      store.dispatch(ClearChannelAction());
      store.dispatch(ClearEPGAction());
    };
  }, []);

  const submitDeleteChannel = () => {
    setIsDeleting(true);
    if (params.id) {
      store.dispatch(DeleteChannelAction(params.id));
    }
  };

  const submitUpdateChannel = (values: any) => {
    const { entitlementCollectionIds, ...channelValues } = values;
    store.dispatch(
      UpdateChannelAction(new CMSAsset(channelValues).serialize())
    );
    if (entitlementCollectionIds) {
      store.dispatch(
        UpdateAssetEntitlementsAction(
          channel!.getUniqueId(),
          entitlementCollectionIds
        )
      );
    }
  };

  const redirect = () => {
    history("/admin/metadata/live-channels");
  };

  return (
    <>
      {channel && (
        <>
          <Formik
            initialValues={channel}
            validationSchema={UpdateChannelSchema}
            onSubmit={(values) => {
              submitUpdateChannel(values);
            }}
          >
            {({ handleSubmit, setFieldValue }) => (
              <Form>
                <DetailPageHeader
                  title="Channel Metadata"
                  entity={channel}
                  onDelete={submitDeleteChannel}
                  onBack={redirect}
                />
                <EPGAccordion channel={channel} />
                <ChannelBasicInformationAccordion providers={providers} />
                <MediaAccordion asset={channel} />
                <LocalizedTextsAccordion />
                <LocalizedImagesAccordion
                  setFieldValue={setFieldValue}
                  assetId={channel.assetId}
                />
                <TagsAccordion />
                <GenresAccordion />
                <MediasAccordion />
                <EntitlementsAccordion assetId={channel.getUniqueId()} />
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
};
